<template>
  <div class="home page text-center">
    <img src="@/assets/img/403.png" width="500px" />
    <h3 class="text-center mb-3">Bạn không có quyền truy cập vào hệ thống</h3>
    <p class="text-center mb-3">
      Vui lòng liên hệ BPGS: <a href="mailto:gs@vimo.vn">gs@vimo.vn</a>
    </p>
    <button type="button" @click="$router.push('/login')" class="m-auto btn btn-success d-block">
      Đăng nhập
    </button>
  </div>
</template>

<script>
  export default {
    name: 'IndexPage',

    components: {},

    data: () => {
      return {
        // msg: 'Welcome to Index!!!',
        isShownModal: false,
        inputError: false,
        checkboxState: false,

        pagination: {
          limit: 20,
          offset: 0,
          total: 60,
        },
      }
    },

    methods: {},
  }
</script>
<style scoped>
  .text-update-content {
    text-align: center;
    font-size: 22px;
    line-height: 100px;
  }
</style>
